// src/sizing/useUnifiedSizing.ts
import { useSyncExternalStore, useCallback } from 'react';
import { runUnifiedSizing } from './runUnifiedSizing';
import { USE_NEW_PIPELINE } from './pipelineFlags';
import { sizingStore } from '@/stores/sizingStore';
import type { NewSizingRequest, NewSizingSnapshot } from './newSizingEngine';

export function useUnifiedSizing() {
  const state = useSyncExternalStore(
    sizingStore.subscribe,
    sizingStore.getSnapshot,
    sizingStore.getSnapshot
  );

  const runSizing = useCallback((req: NewSizingRequest) => {
    if (!USE_NEW_PIPELINE) {
      console.warn('[UnifiedSizing] USE_NEW_PIPELINE disabled; skipping unified compute.');
      return;
    }
    sizingStore.setStatus('running');
    try {
      const result = runUnifiedSizing(req);
      sizingStore.setSnapshot(result, req);
    } catch (err) {
      sizingStore.setError(err instanceof Error ? err : new Error('Unified sizing failed'));
    }
  }, []);

  return {
    status: state.status,
    snapshot: state.snapshot,
    request: state.request,
    hasEstimate: Boolean(state.snapshot),
    error: state.error,
    runSizing,
    compute: runSizing,
    loading: state.status === 'running',
    mcDebug: null as null | unknown,
  };
}

export type { NewSizingSnapshot, NewSizingRequest };
